// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/HomeProjectPicker.test.tsx
import { Info } from "@phosphor-icons/react";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { Tooltip } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

/**
 * Explains that Project mode posts to the shared feed. Lives in the home
 * Project-mode picker lane, after the dropdown — and after the clear control
 * when a project is selected. The lane only mounts in Project mode.
 */
export function HomeProjectChatInfoButton({
  testIdPrefix = "ask-puntt-home",
}: {
  testIdPrefix?: string;
}) {
  const { t } = useTranslation("ui");

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip
        content={
          <span data-testid={`${testIdPrefix}-project-chat-info-tooltip`}>
            {t("home.projectChatInfoTooltip")}
          </span>
        }
        side="bottom"
      >
        <button
          type="button"
          data-testid={`${testIdPrefix}-project-chat-info`}
          aria-label={t("home.projectChatInfoAriaLabel")}
          className="flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-xl bg-transparent text-puntt-neutral-gray-9 transition-colors hover:bg-puntt-neutral-gray-2 hover:text-puntt-neutral-gray-12"
        >
          <Info size={14} weight="regular" aria-hidden="true" />
        </button>
      </Tooltip>
    </TooltipProvider>
  );
}
